import { render, staticRenderFns } from "./AgeIcon.vue?vue&type=template&id=42ed96c8"
import script from "./AgeIcon.vue?vue&type=script&lang=js"
export * from "./AgeIcon.vue?vue&type=script&lang=js"
import style0 from "./AgeIcon.vue?vue&type=style&index=0&id=42ed96c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports